
var atheneumInstance = SalesToolkit;

/**
 * CrossPlatform Atheneum implementation, working with Xamarin / Visual Studio
 * in C# to handle requests and storage 
 * @param {Atheneum} atheneum
 * @param {boolean} enabled
 */
Atheneum.CrossPlatform = function CrossPlatform(atheneum, enabled) {

    if (!(this instanceof Atheneum.CrossPlatform))
        return new Atheneum.CrossPlatform(atheneum, enabled);

    this.deviceType = this.getMobileOperatingSystem();
    this.enabled = enabled;
    this.Callbacks = new Atheneum.CrossPlatform.Callbacks(this);
    this.Atheneum = atheneum;
    this.remember = false;
    this.localCache = {};
    this.urlRewriteCache = {};

    window.onerror = (msg, url, line, column, error) => {
        const message = {
            message: msg,
            url: url,
            line: line,
            column: column,
            error: JSON.stringify(error)
        }

        try {
            if (window.webkit) {
                window.webkit.messageHandlers.error.postMessage(message);
            } else if (window.AndroidBridge) {
                AndroidBridge.handleJavascriptError(JSON.stringify(obj));
            } else {
                console.log("Error:", message);
            }
        } catch (err) {
            console.log("Error:", message);
        }

       
    };

    
    this.Promises = new Atheneum.CrossPlatform.Promises(this);

    try {
        if (this.enabled) {
            Atheneum.Proxy.enabled = false;
        }
    } catch (e) {
        console.log(e);
    }
}

//#region Login Region
/**
 * CrossPlatform implementation of login. Handles login request and persists
 * the user data in the sqlite db. {jsonCallback} is an object that contains a
 * 
 
 * @param {any} username
 * @param {any} password
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.login = function (username, password, jsonCallback, persist) {
    if (username == undefined || password == undefined)
        throw new IllegalArgumentException("username and password are required");
    if (persist == undefined)
        persist = true;

    this.Callbacks.addCallbacks("login", jsonCallback);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.login.postMessage({ "userName": username, "password": password, "remember": this.remember, "persist": persist });
    } else if (this.isAndroid()) {
        var obj = { "userName": username, "password": password, "remember": this.remember, "persist": persist };

        AndroidBridge.login(JSON.stringify(obj));
    } else {

        var queryParams = {
            appVersion: this.Atheneum.version
        }

        var requestBody = { userName: username, password: password };

        // device info

        requestBody.appType = "webapp";
        requestBody.appName = "salestoolkit";
        requestBody.appUrl = window.location.host;
        requestBody.appVersion = this.Atheneum.version;
        requestBody.deviceIdiom = Atheneum.Device.getCategory();
        requestBody.deviceOSVersion = Atheneum.Device.getOSVersion();
        requestBody.devicePlatform = Atheneum.Device.getOSName();
        requestBody.browserName = Atheneum.Device.getBrowserName();
        requestBody.browserVersion = Atheneum.Device.getBrowserVersion();
        requestBody.screenSize = Atheneum.Device.getScreenDimensions();

        for (var prop in requestBody) {
            if (requestBody.hasOwnProperty(prop) && requestBody[prop] == null) {
                delete requestBody[prop];
            }
        }

        return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/login", requestBody, queryParams, jsonCallback);
    }

    return this.Callbacks.login;
}

/**
 * CrossPlatform implementation of initiate-login. Handles single signon login request  {jsonCallback} is an object that contains a success and failure funciton
 * 
 
 * @param {any} username
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.initiateLogin = function (username, jsonCallback) {
    if (username == undefined)
        throw new IllegalArgumentException("username is required");

    this.Callbacks.addCallbacks("initiateLogin", jsonCallback);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.initiateLogin.postMessage({ "userName": username });
    } else if (this.isAndroid()) {
        var obj = { "userName": username };

        AndroidBridge.initiateLogin(JSON.stringify(obj));
    } else {

        var queryParams = {
            appVersion: this.Atheneum.version
        }

        var requestBody = { userName: username };

        // device info

        requestBody.appType = "webapp";
        requestBody.appName = "salestoolkit";
        requestBody.appUrl = window.location.host;
        requestBody.appVersion = this.Atheneum.version;
        requestBody.deviceIdiom = Atheneum.Device.getCategory();
        requestBody.deviceOSVersion = Atheneum.Device.getOSVersion();
        requestBody.devicePlatform = Atheneum.Device.getOSName();
        requestBody.browserName = Atheneum.Device.getBrowserName();
        requestBody.browserVersion = Atheneum.Device.getBrowserVersion();
        requestBody.screenSize = Atheneum.Device.getScreenDimensions();

        for (var prop in requestBody) {
            if (requestBody.hasOwnProperty(prop) && requestBody[prop] == null) {
                delete requestBody[prop];
            }
        }

        return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.SERVER_INSTANCE_BASE_URL + "/initiate-login", requestBody, queryParams, jsonCallback);
    }

    return this.Callbacks.initiateLogin;
}

/**
 * Callback from native code once login is finished
 * @param {any} success boolean succeded or failed 
 * @param {any} returnJSON from the request on success
 * @param {any} reason for failure only
 * @param {any} httpCode http code on failure only
 * @param {any} errorCode error code on failure only
 */
Atheneum.CrossPlatform.prototype.loginFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.login === 'undefined' || this.Callbacks.login == null)
        return;

    var callbacks = this.Callbacks.login;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else
        callbacks.failure(reason, httpCode, errorCode);
}

/**
 * Callback from native code once login is finished
 * @param {any} success boolean succeded or failed 
 * @param {any} returnJSON from the request on success
 * @param {any} reason for failure only
 * @param {any} httpCode http code on failure only
 * @param {any} errorCode error code on failure only
 */
Atheneum.CrossPlatform.prototype.initiateLoginFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.initiateLogin === 'undefined' || this.Callbacks.initiateLogin == null)
        return;

    var callbacks = this.Callbacks.initiateLogin;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else
        callbacks.failure(reason, httpCode, errorCode);
}

/**
 * CrossPlatform implementation of logout. Removes api key and current user. If 
 * forgetUser is used it will also remove secure store of user / pass 
 * @param {any} forgetUser
 * @param {any} callbacks
 */
Atheneum.CrossPlatform.prototype.logout = function (forgetUser, callbacks) {
    if (typeof forgetUser === 'undefined')
        forgetUser = true;

    this.Callbacks.addCallbacks("logout", callbacks);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.logout.postMessage({ "forgetUser": forgetUser });
    } else if (this.isAndroid()) {
        var obj = { "forgetUser": forgetUser };

        AndroidBridge.logout(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("logout");
    }

    return this.Callbacks.logout;
}


Atheneum.CrossPlatform.prototype.copyToClipboard = function (text) {
    if (typeof text === 'undefined')
        return false;

   
    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.copyToClipboard.postMessage({ "text": text });
    } else if (this.isAndroid()) {
        var obj = { "text": text };

        AndroidBridge.copyToClipboard(JSON.stringify(obj));
    } else {

    }

    return true;
}

/**
 * Callback from native code once logout is finished
 *  @param {any} jsonResponse response from logout, if logout  type is DEFAULT logout can proceed as normal
 */
Atheneum.CrossPlatform.prototype.logoutFinished = function (jsonResponse) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.logout === 'undefined' || this.Callbacks.logout == null)
        return;

    var callbacks = this.Callbacks.logout;

    if (typeof callbacks.success === "function")
        callbacks.success(jsonResponse);
}
//#endregion

//#region Contacts
/**
 * Select contact  from device
 * @param {any} callbacks
 */
Atheneum.CrossPlatform.prototype.selectContact = function (callbacks) {
    this.Callbacks.addCallbacks("selectContact", callbacks);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.selectContact.postMessage({ });
    } else if (this.isAndroid()) {
        var obj = {  };

        AndroidBridge.selectContact(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("selectContact");
    }

    return this.Callbacks.logout;
}


/**
 * Callback from native code once selectContact is finished. Failure is called if user cancelled
 */
Atheneum.CrossPlatform.prototype.selectContactFinished = function (success, email) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.selectContact === 'undefined' || this.Callbacks.selectContact == null)
        return;

    var callbacks = this.Callbacks.selectContact;

    if (success) {
        callbacks.success(email);
    }
    else
        callbacks.failure();

    this.Callbacks.removeCallbacks("selectContact");

}
//#endregion


//#endregion

//#region Forms
/**
 * form submission
 * @param {any} formId
 * @param {any} parameters
 * @param {any} callbacks
 */
Atheneum.CrossPlatform.prototype.submitForm = function (formId, parameters, callbacks) {
    if (typeof formId !== 'string' || typeof parameters !== 'object')
        throw new IllegalArgumentException("formId and / or parameters must not be undefined. formId must be a string and parameters must be an object");

    this.Callbacks.addCallbacks("submitForm", callbacks);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.submitForm.postMessage({ "id": formId, "parameters": parameters });
    } else if (this.isAndroid()) {
        var obj = { "id": formId, "parameters": parameters };

        AndroidBridge.submitForm(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("submitForm");
    }

    return this.Callbacks.logout;
}


/**
 * Callback from native code once form submission is finished
 */
Atheneum.CrossPlatform.prototype.submitFormFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.submitForm === 'undefined' || this.Callbacks.submitForm == null)
        return;

    var callbacks = this.Callbacks.submitForm;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else
        callbacks.failure(reason, httpCode, errorCode);

    this.Callbacks.removeCallbacks("submitForm");
}
//#endregion

/**
 * Bit of an ugly way to get some translations into the app side, only used for android at the moment
 */
Atheneum.CrossPlatform.prototype.loadTranslations = function () {
    

    if (this.isIOS()) {
       //Not needed for iOS
    } else if (this.isAndroid()) {
        var obj = {
            "changeAvatar": this.Atheneum.Translation.get("changeAvatar", "Change Avatar"),
            "takePhotoButton": this.Atheneum.Translation.get("takePhotoButton", "Take Photo"),
            "fromLibraryButton": this.Atheneum.Translation.get("fromLibraryButton", "From Library"),
            "cancelButton": this.Atheneum.Translation.get("cancelButton", "Cancel"),
            "offlineSendsNotificationTitle": this.Atheneum.Translation.get("offlineSendsNotificationTitle", "Alert!"),
            "offlineSendsNotificationText": this.Atheneum.Translation.get("offlineSendsNotificationText", "You have {0} offline transactions waiting to be sent"),
            "uploadFiles": this.Atheneum.Translation.get("uploadFiles", "Upload Files")
        };

        AndroidBridge.loadTranslations(JSON.stringify(obj));
    } 

}

Atheneum.CrossPlatform.prototype.takeScreenshot = function (callbacks) {

    this.Callbacks.addCallbacks("takeScreenshot", callbacks);

    if(this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.takeScreenshot.postMessage({ "action" : "take screenshot" });
    } else if (this.isAndroid()) {
        var obj = { "action": "take screenshot" };

        AndroidBridge.takeScreenshot(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("takeScreenshot");
    }

    return this.Callbacks.takeScreenshot;
}

Atheneum.CrossPlatform.prototype.takeScreenshotFinished = function (success, message) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.takeScreenshot === 'undefined' || this.Callbacks.takeScreenshot == null)
        return;

    var callbacks = this.Callbacks.takeScreenshot;

    if (success) {
        callbacks.success(message);
    }
    else
        callbacks.failure(message);

    this.Callbacks.removeCallbacks("takeScreenshot");
}

//#region Library Region
/**
 * CrossPlatform implementation of library update. Handles library request and persists
 * the user data in the sqlite db. {jsonCallback} is an object that contains a
 * 
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.updateLibrary = function (jsonCallback, useTimestamp) {

    this.Callbacks.addCallbacks("libraryUpdate", jsonCallback);
    var timestampUse = (useTimestamp === true) ? "true" : "false";
    if (this.isIOS()) {
        window.webkit.messageHandlers.updateLibrary.postMessage({ "useTimestamp": timestampUse });
    } else if (this.isAndroid()) {
        var obj = { "useTimestamp": timestampUse};
        AndroidBridge.updateLibrary(JSON.stringify(obj));

    } else {
        var atheneumLibrary = this.Atheneum.Library;
        return this.Atheneum.API.getLibrary(0, {

            success: function (json) {

                // remove deleted assets

                atheneumLibrary.timestamp = json.libraryTimestamp;

                if (json.deletedStories != undefined)
                    for (var i = 0; i < json.deletedStories.length; i++)
                        atheneumLibrary.handleCollectionDeletion(json.deletedStories[i]);

                if (json.deletedAssets != undefined)
                    for (var i = 0; i < json.deletedAssets.length; i++)
                        atheneumLibrary.handleAssetDeletion(json.deletedAssets[i]);

                for (var i = 0; i < json.stories.length; i++) {
                    atheneumLibrary.handleCollectionUpdate(json.stories[i], null);
                }

                atheneumLibrary.saveToStorage();
                var successCallback = jsonCallback.success;
                if (successCallback != undefined)
                    successCallback(json);
            },

            failure: jsonCallback.failure

        });
    }

    return this.Callbacks.login;
}

/**
 * Callback from native code once library update is finished
 * @param {any} success boolean succeded or failed 
 * @param {any} returnJSON from the request on success
 * @param {any} reason for failure only
 * @param {any} httpCode http code on failure only
 * @param {any} errorCode error code on failure only
 */
Atheneum.CrossPlatform.prototype.updateLibraryFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.libraryUpdate === 'undefined' || this.Callbacks.libraryUpdate == null)
        return;

    var callbacks = this.Callbacks.libraryUpdate;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}

Atheneum.CrossPlatform.prototype.updateNewsFeed = function (jsonCallback, useTimestamp) {

    this.Callbacks.addCallbacks("newsFeedUpdate", jsonCallback);
    var timestampUse = (useTimestamp === true) ? "true" : "false";
    if (this.isIOS()) {
        window.webkit.messageHandlers.updateNewsFeed.postMessage({ "useTimestamp": timestampUse });
    } else if (this.isAndroid()) {
        var obj = { "useTimestamp": timestampUse };
        AndroidBridge.updateNewsFeed(JSON.stringify(obj));
    } else {
        var atheneumNewsFeed = this.Atheneum.NewsFeed;
        successCallback = jsonCallback.success || function () { };
        failureCallback = jsonCallback.failure || function (reason, httpStatus, errorCode) {  };
        return this.Atheneum.API.getFeedItems(null, undefined, {

            success: function (json) {
                atheneumNewsFeed.__realItems = {};
                if (json.items) {
                    for (var i = 0; i < json.items.length; i++) {
                        atheneumNewsFeed.handleItemUpdate(json.items[i]);
                    }
                }
                var lastTimestamp = atheneumNewsFeed.timestamp;
                atheneumNewsFeed.timestamp = json.timestamp;
                atheneumNewsFeed.applyOfflineChanges(false);
                atheneumNewsFeed.saveToStorage();

                atheneumNewsFeed.updateUnreadReplies(lastTimestamp);

                if (typeof successCallback === "function")
                    successCallback(json);
            },

            failure: failureCallback
        });
    }

    return this.Callbacks.login;
}

/**
 * Callback from native code once library update is finished
 * @param {any} success boolean succeded or failed 
 * @param {any} returnJSON from the request on success
 * @param {any} reason for failure only
 * @param {any} httpCode http code on failure only
 * @param {any} errorCode error code on failure only
 */
Atheneum.CrossPlatform.prototype.updateNewsFeedFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.newsFeedUpdate === 'undefined' || this.Callbacks.newsFeedUpdate == null)
        return;

    var callbacks = this.Callbacks.newsFeedUpdate;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}

/**
 * Crossplatform implementationfor downloading assets. Currently uses the same
 * calls as getAssetPreview with a different default return
 * @param {any} assetId
 * @param {any} collectionId
 * @param {any} jsonCallback
 */
Atheneum.CrossPlatform.prototype.downloadAsset = function (assetId, collectionId, jsonCallback) {
    this.Callbacks.addCallbacks("getAssetPreview", jsonCallback);
    if (this.isIOS()) {
        window.webkit.messageHandlers.getAssetPreview.postMessage({ "assetId": assetId });
    } else if (this.isAndroid()) {
        var obj = { "assetId": assetId };
        AndroidBridge.getAssetPreview(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("getAssetPreview");
        this.Atheneum.API.getAssetDownloadLink(collectionId, assetId, {

            success: function (json) {

                var fileUrl = json.link + "?apikey=" + atheneumLibrary.Atheneum.User.apikey;
                var fileName = (atheneumLibrary.assets[assetId] || {}).name || ("asset" + assetId);

                // TODO: prompt to download file with correct filename

                var downloadLink = document.createElement("A");
                downloadLink.href = fileUrl;
                document.querySelector("body").appendChild(downloadLink);
                downloadLink.click();
                document.querySelector("body").removeChild(downloadLink);

                return callbacks.success();

            },

            failure: function (reason, httpStatus, errorCode) {
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Library.downloadAsset");

                return callbacks.failure();
            }
        });
        return;
    }

    return this.Callbacks.getAssetPreview;
}

//#endregion

//#region Get Asset Preview Region
/**
 * CrossPlatform implementation of asset preview
 * the user data in the sqlite db. {jsonCallback} is an object that contains a
 * 
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.getAssetPreview = function (assetId, jsonCallback) {

    this.Callbacks.addCallbacks("getAssetPreview", jsonCallback);
    if (this.isIOS()) {
        window.webkit.messageHandlers.getAssetPreview.postMessage({ "assetId": assetId });
    } else if (this.isAndroid()) {
        var obj = { "assetId": assetId };
        AndroidBridge.getAssetPreview(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("getAssetPreview");
        return this.getAssetPreviewDefault(assetId, jsonCallback);
    }

    return this.Callbacks.getAssetPreview;
}

/**
 * Callback once getAssetPreview has processed the request
 * @param {any} result
 * @param {any} assetId
 */
Atheneum.CrossPlatform.prototype.getAssetPreviewFinished = function (result, assetId) {
    if (typeof this.Callbacks.getAssetPreview === 'undefined' || this.Callbacks.getAssetPreview == null)
        return;
   
    var callbacks = this.Callbacks.getAssetPreview;
    if (result == '')
        this.getAssetPreviewDefault(assetId, callbacks);
    else {
       
        if (!result.startsWith("file://")) {
            result = "file://" + result;
        }

        var connection = {};
        connection.responseText = this.getAssetPreviewHTML(assetId, result);
        if (window.jwPlayerScript) {
            connection.script = window.jwPlayerScript;
        }
        connection.fileUrl = result;
        //connection.pdfAsArray = pdfAsArray;
        callbacks.success(connection);
    }
}

Atheneum.CrossPlatform.prototype.loadNativePDFViewer = function (assetId, offset, width, height) {
    var parameters = {};
    parameters.offset = offset;
    parameters.width = width;
    parameters.height = height;
    parameters.assetId = assetId;

    if (this.isIOS()) {
        window.webkit.messageHandlers.loadNativePDFViewer.postMessage(parameters);
        return true;
    } else if (this.isAndroid()) {
        //AndroidBridge.loadNativePDFViewer(JSON.stringify(parameters));
        //return true;
    }

    return false;
}

/**
 * Callback once getAssetPreview has processed the request and it turned out to be a streaming location
 * @param {any} result
 * @param {any} assetId
 */
Atheneum.CrossPlatform.prototype.getAssetPreviewFinishedForStreamingLocation = function (css, js, elements) {
    if (typeof this.Callbacks.getAssetPreview === 'undefined' || this.Callbacks.getAssetPreview == null)
        return;
    if (css !== '') {
        var element = document.getElementsByTagName("head")[0];
        if (element)
            element.insertAdjacentHTML( 'beforeend', css );
    }

    if (js !== '') {
        var element = document.getElementsByTagName("head")[0];
        if (element)
            element.insertAdjacentHTML('beforeend', js);
    }

    if (typeof elements === 'undefined')
        elements = '';

    var callbacks = this.Callbacks.getAssetPreview;

    var connection = {};
    connection.responseText = elements;
    callbacks.success(connection);
}



/**
 * CrossPlatform implementation of share / download document
 * the user data in the sqlite db. {jsonCallback} is an object that contains a
 * 
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.shareDocument = function (assetIdOrUrl, x, y, width, height, mimetype, fileName, jsonCallback) {

    this.Callbacks.addCallbacks("shareDocument", jsonCallback);
    if (typeof x !== 'number')
        x = 0;
    if (typeof y !== 'number')
        y = 0;
    if (typeof width !== 'number')
        width = 0;
    if (typeof height !== 'number')
        height = 0;

    var obj = { "assetIdOrUrl": assetIdOrUrl };
    obj.x = x;
    obj.y = y;
    obj.width = width;
    obj.height = height;
    obj.mimetype = mimetype;
    obj.filename = fileName;

    var maxSizeDownloads = atheneumInstance.User.getPreference('salestoolkitAppSettingMobileMaxSize', '0', false);
    obj.maxSize = parseFloat(maxSizeDownloads);

    if (this.isIOS()) {
        window.webkit.messageHandlers.shareDocument.postMessage(obj);
    } else if (this.isAndroid()) {
        AndroidBridge.shareDocument(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("shareDocument");
    }

    return this.Callbacks.shareDocument;
}

/**
 * Callback once shareDocument has processed the request
 * @param {any} result
 * @param {any} assetId
 */
Atheneum.CrossPlatform.prototype.shareDocumentFinished = function (result) {
    if (typeof this.Callbacks.shareDocument === 'undefined' || this.Callbacks.shareDocument == null)
        return;

    var callbacks = this.Callbacks.shareDocument;

    if (result) {
        if (typeof callbacks == "object" && callbacks.success) {
            callbacks.success();
        } else {
            callbacks(true);
        }
    }

    if (typeof callbacks == "object" && callbacks.failure) {
        callbacks.failure();
    } else {
        callbacks(false);
    }

    this.Callbacks.removeCallbacks("shareDocument");
}

Atheneum.CrossPlatform.prototype.shareDocumentProgress = function (percentage) {
    if (typeof this.Callbacks.shareDocument === 'undefined' || this.Callbacks.shareDocument == null)
        return;

    var callbacks = this.Callbacks.shareDocument;

    if (percentage) {
        if (typeof callbacks == "object" && callbacks.progress) {
            callbacks.progress(percentage);
        } 
    } 
}

/**
 * Helper method to construct the final html to be used to preview   an asset
 * @param {any} assetId
 * @param {any} src
 */
Atheneum.CrossPlatform.prototype.getAssetPreviewHTML = function (assetId, src) {
    var asset = this.Atheneum.Library.assets[assetId];
    var failed = false;
    if (asset) {
        var collectionId = asset.containedBy;

        if (asset.canPreview === false) {
            if (typeof callback == "object" && callback.failure) {
                callback.failure({ status: 404, responseText: "" });
            } else {
                ((typeof callback == "function") ? callback : callback.success)({ responseText: "<p>Asset Preview Not Allowed</p>", status: 200 });
            }
        }

        let atheneum = this.Atheneum;
        var result = "";
        if (!atheneum.Theme.getBooleanProperty('ignoreStreamingLocations', false)
            && asset.streamingLocations
            && asset.streamingLocations.length > 0
            && asset.streamingLocations.filter(function (s) { return s.type == 'JWPlayer' || s.type == 'JW Player'; }).length > 0) {

            delete window.jwplayer;

            var streamingLocation = asset.streamingLocations.filter(function (s) { return s.type == 'JWPlayer' || s.type == 'JW Player'; })[0];

            var jwPlayerVideoKey = streamingLocation.videoKey || (streamingLocation.properties || {}).videoKey || '';
            var jwPlayerPlayerKey = streamingLocation.playerKey || (streamingLocation.properties || {}).playerKey || '';

            var jwPlayerStreamKey = streamingLocation.key || (streamingLocation.properties || {}).key || (jwPlayerVideoKey + '-' + jwPlayerPlayerKey);

            var jwPlayerDivId = 'botr_' + jwPlayerVideoKey + '_' + jwPlayerPlayerKey + '_div';

            var jwPlayerPlayerScriptSrc = 'https://cdn.jwplayer.com/libraries/' + jwPlayerPlayerKey + '.js';

            var jwPlayerVideoPlaylistUrl = 'https://cdn.jwplayer.com/v2/media/' + jwPlayerVideoKey;


            // NOTE: jwplayer has a bug in their default embed script that causes the player to fail to load
            // with an error about being unable to parse an rss feed. That was fun to discover a workaround for

            //var jwPlayerEmbedScriptSrc = 'https://cdn.jwplayer.com/players/' + jwPlayerStreamKey + '.js';

            result = '<div class="assetPreviewVideoStream assetPreviewMedia">'
                + '<div class="jwplayer-container">'
                + '<div id="' + jwPlayerDivId + '" class="jwplayer-replacement"></div>'
                + '</div>'
                + '</div>'
            window.jwPlayerScript = document.createElement('SCRIPT');
            jwPlayerScript.addEventListener('load', function () {
                // wait for script to run to avoid race conditions
                Atheneum.HttpUtils.getJSON(jwPlayerVideoPlaylistUrl, function (json) {

                    if (!window.jwplayer) {
                        return;
                    }
                    var playlist = json.playlist;
                    if (!playlist) {
                        return;
                    }
                    var jwplayerInstance = jwplayer(document.getElementById(jwPlayerDivId));
                    if (!jwplayerInstance) {
                        return;
                    }
                    jwplayerInstance.setup({
                        "playlist": playlist
                    });

                    if (jwplayerInstance.onReady) {
                        jwplayerInstance.onReady(function () {

                            if (atheneum.Theme.getBooleanProperty('playVideosOnce', true)) {
                                jwplayerInstance.onComplete(showCertificateFormIfExistsOrTriggerBackButtonClick);
                            }
                            else {
                                // jwplayer doesn't have a nice way of looping, need to do it manually
                                jwplayerInstance.onBeforeComplete(function () {
                                    jwplayerInstance.seek(0);
                                    jwplayerInstance.play();
                                });
                            }

                            jwplayerInstance.onPlay(onVideoPlaying);
                            jwplayerInstance.onTime(onVideoPlaying);
                            jwplayerInstance.onFirstFrame(onVideoPlaying);

                            jwplayerInstance.onComplete(onVideoPausedOrStopped);
                            jwplayerInstance.onPause(onVideoPausedOrStopped);
                            //jwplayerInstance.on('idle', onVideoPausedOrStopped);
                            //jwplayerInstance.on('error', onVideoPausedOrStopped);
                        });
                    }
                    else {
                        jwplayerInstance.on('ready', function () {

                            jwplayerInstance.on('firstFrame', function () {
                                atheneum.currentTrackedPreview = atheneum.Tracking.startTrackingAssetView(assetId);
                                $('#videoSection').data('previewLoadTime', '' + (new Date().getTime()));
                                onVideoPlaying();
                            });

                            if (atheneum.Theme.getBooleanProperty('playVideosOnce', true)) {
                                jwplayerInstance.on('complete', showCertificateFormIfExistsOrTriggerBackButtonClick);
                            }
                            else {
                                // jwplayer doesn't have a nice way of looping, need to do it manually
                                jwplayerInstance.on('beforeComplete', function () {
                                    jwplayerInstance.seek(0);
                                    jwplayerInstance.play();
                                });
                            }

                            jwplayerInstance.on('play', onVideoPlaying);
                            jwplayerInstance.on('time', onVideoPlaying);

                            jwplayerInstance.on('complete', onVideoPausedOrStopped);
                            jwplayerInstance.on('pause', onVideoPausedOrStopped);
                            //jwplayerInstance.on('idle', onVideoPausedOrStopped);
                            //jwplayerInstance.on('error', onVideoPausedOrStopped);
                        });
                    }
                });
            });
            jwPlayerScript.setAttribute('src', jwPlayerPlayerScriptSrc);

        } else if (asset.mimetype == "application/pdf") {
            window.DEFAULT_PDF_URL = encodeURIComponent(src);
            result = "<iframe width='100%' height='100%' style='z-index: 0; border:none;' wmode='opaque' src='plugins/pdfjs/web/viewer.html?file=" + src + "#toolbar=0&navpanes=0&scrollbar=1' />";
        }
        else if (asset.mimetype == "image/vnd.dwg" || asset.mimetype == "image/x-dwg") {
            //Cad files not available for preview in web app
            failed = true;
        }
        else if (asset.mimetype.startsWith("image")) {
            result = "<img src='" + src + "' />";
        } else if (asset.mimetype == "application/zip" && asset.contentMimetype == "text/html") {
            result = "<iframe data-assetId= '" + assetId + "' src='" + src + "' width='100%' height='100%' class='presentation' />";
        }
        else if (asset.mimetype == "video/x-ms-wmv") {
            result = "<object "
                + "width=\"100%\" "
                + "height=\"100%\" "
                + "classid=\"CLSID:22d6f312-b0f6-11d0-94ab-0080c74c7e95\" "
                + "codebase=\"http://activex.microsoft.com/activex/controls/mplayer/en/nsmp2inf.cab#Version=5,1,52,701\" "
                + "standby=\"Loading Microsoft Windows Media Player components...\" "
                + "type=\"application/x-oleobject\"> "
                + "<param name=\"fileName\" value=\"" + src + "\"> "
                + "<param name=\"animationatStart\" value=\"true\"> "
                + "<param name=\"transparentatStart' value=\"true\"> "
                + "<param name=\"autoStart' value=\"false\"> "
                + "<param name=\"showControls' value=\"true\"> "
                + "<param name=\"loop\" value=\"false\"> "
                + "<embed type=\"application/x-mplayer2\" "
                + "pluginspage=\"http://microsoft.com/windows/mediaplayer/en/download/\" "
                + "showcontrols=\"true\" "
                + "width=\"100%\" "
                + "height=\"100%\" "
                + "src=\"" + src + "\" autostart=\"true\" designtimesp='5311' loop=\"true\"> "
                + "</embed> "
                + "</object>";
        }
        else if (asset.mimetype.startsWith("video")) {

            result = "<video controls autoplay src='" + src + "'/>";
        }
        else if (asset.mimetype == "asset/url") {
           
            if (asset.url) {
                result = asset.url;
            } else {
                failed = true;
            }

        }
        else if (asset.mimetype == "text/html") { // not sure there are actually any of these,but just in case
            result = "<iframe src='" + src + "' width='100%' height='100%'/>";
        }
        else if (asset.mimetype == "text/plain") {
            result = "<iframe src='" + src + "' width='100%' height='100%'/>";
        }
        else if (asset.mimetype == "application/zip") {
            var zipSrc = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "/zip/index.html?apikey=" + this.Atheneum.User.apikey;
            result = "<iframe src='" + zipSrc + "' width='100%' height='100%'/>";
        }
        else {
            failed = true;
        }

        if (!failed)
            return result;

    }
    return null;

}

/**
 * Returns the default web only version of the html used for preview (direct html file request rather than using the local file)
 * @param {any} assetId
 * @param {any} callback
 */
Atheneum.CrossPlatform.prototype.getAssetPreviewDefault = function(assetId, callback) {
    var asset = this.Atheneum.Library.assets[assetId];
    var failed = false;
    if (asset) {
        var collectionId = asset.containedBy;

        if (asset.canPreview === false) {
            if (typeof callback == "object" && callback.failure) {
                callback.failure({ status: 404, responseText: "" });
            } else {
                ((typeof callback == "function") ? callback : callback.success)({ responseText: "<p>Asset Preview Not Allowed</p>", status: 200 });
            }
        }
        var result = "";
        var src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "?apikey=" + this.Atheneum.User.apikey;
        if (asset.mimetype == "application/pdf") {
           // result = "<embed width='100%' height='100%' name='plugin' style='z-index: 0;' wmode='opaque' data='" + src + "#toolbar=0&navpanes=0&scrollbar=1' type = 'application/pdf' /> ";
            //result = "<div><object width='100%' height='100%' style='z-index: 0;' wmode='opaque' data='" + src + "#toolbar=0&navpanes=0&scrollbar=1'><param name=\"wmode\" value=\"opaque\" /><p>Previewing this Asset requires </p></object></div>"; // download.pdf -> browser attempts to download it and breaks the preview
            window.DEFAULT_PDF_URL = encodeURIComponent(src);
            result = '<div style="height: 100%; min-height: 100%;"><iframe width="100%" height="100%" style="z-index: 0; border:none;" wmode="opaque" src="plugins/pdfjs/web/viewer.html?file=' + encodeURIComponent(src) + '" />';
        }
        else if (asset.mimetype == "image/vnd.dwg" || asset.mimetype == "image/x-dwg") {
            //Cad files not available for preview in web app
            failed = true;
        }
        else if (asset.mimetype.startsWith("image")) {
            result = "<img src='" + src + "' />";
        }
        else if (asset.mimetype == "video/x-ms-wmv") {

            var networkInfo = (navigator) ? navigator.connection : null;
            var quality = "HIGH";
            if (networkInfo) {
                if (networkInfo.type == "cellular" || networkInfo.type == "bluetooth") {
                    if (network.effectiveType != "4g" && network.effectiveType != "5g")
                        quality = "LOW";
                }
            }

            src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "/stream/" + quality + "?apikey=" + this.Atheneum.User.apikey;

            result = "<object "
                + "width=\"100%\" "
                + "height=\"100%\" "
                + "classid=\"CLSID:22d6f312-b0f6-11d0-94ab-0080c74c7e95\" "
                + "codebase=\"http://activex.microsoft.com/activex/controls/mplayer/en/nsmp2inf.cab#Version=5,1,52,701\" "
                + "standby=\"Loading Microsoft Windows Media Player components...\" "
                + "type=\"application/x-oleobject\"> "
                + "<param name=\"fileName\" value=\"" + src + "\"> "
                + "<param name=\"animationatStart\" value=\"true\"> "
                + "<param name=\"transparentatStart' value=\"true\"> "
                + "<param name=\"autoStart' value=\"false\"> "
                + "<param name=\"showControls' value=\"true\"> "
                + "<param name=\"loop\" value=\"false\"> "
                + "<embed type=\"application/x-mplayer2\" "
                + "pluginspage=\"http://microsoft.com/windows/mediaplayer/en/download/\" "
                + "showcontrols=\"true\" "
                + "width=\"100%\" "
                + "height=\"100%\" "
                + "src=\"" + src + "\" autostart=\"true\" designtimesp='5311' loop=\"true\"> "
                + "</embed> "
                + "</object>";
        }
        else if (asset.mimetype.startsWith("video")) {
            var networkInfo = (navigator) ? navigator.connection : null;
            var quality = "HIGH";
            if (networkInfo) {
                if (networkInfo.type == "cellular" || networkInfo.type == "bluetooth") {
                    if (network.effectiveType != "4g" && network.effectiveType != "5g")
                        quality = "LOW";
                }
            }

            src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "/stream/" + quality + "?apikey=" + this.Atheneum.User.apikey;

            result = "<video controls autoplay src='" + src + "'/>";
        }
        else if (asset.mimetype == "asset/url") {
            if (asset.url) {
                result = asset.url;
            } else {
                failed = true;
            }

        }
        else if (asset.mimetype == "text/html") { // not sure there are actually any of these,but just in case
            result = "<iframe src='" + src + "' width='100%' height='100%'/>";
        }
        else if (asset.mimetype == "text/plain") {
            result = "<iframe src='" + src + "' width='100%' height='100%'/>";
        }
        else {
            failed = true;
        }

        if (failed === false && callback.success) {
            if (typeof callback == "object" && callback.success)
                callback.success({ responseText: result, status: 200 });
            else
                callback({ responseText: result, status: 200 });
        }

    }f
    if (failed === true) {
        if (typeof callback == "object" && callback.failure) {
            callback.failure({ status: 404, responseText: "" });
        } else {
            ((typeof callback == "function") ? callback : callback.success)({ responseText: "<p>Asset Preview Unavailable</p>", status: 200 });
        }
    }
}

//#endregion

/**
 * Get Connectivity Status
 * @param {any} key
 */
Atheneum.CrossPlatform.prototype.isOnline = function () {

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (navigator)
            return navigator.onLine;
        else
            return true;
    }

    if (this.isIOS()) {
        return this.Prompt("connectivityStatus", {  }) == "online";
    } else if (this.isAndroid()) {
        return this.Prompt("connectivityStatus", {  }) == "online";
        //console.log("android todo");
    } else if (navigator) {
        return navigator.onLine;
    }

    return true;
}

Atheneum.CrossPlatform.prototype.isMobileNetwork = function () {

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (navigator)
            return false;
        else
            return false;
    }

    if (this.isIOS()) {
        return this.Prompt("connectivityType", {}) == "mobile";
    } else if (this.isAndroid()) {
        return this.Prompt("connectivityType", {}) == "mobile";
        //console.log("android todo");
    }

    return false;
}

Atheneum.CrossPlatform.prototype.isWiFi = function () {

    if (this.isIOS()) {
        return this.Prompt("connectivityType", {}) == "wifi";
    } else if (this.isAndroid()) {
        return this.Prompt("connectivityType", {}) == "wifi";
        //console.log("android todo");
    }

    return true;
}

Atheneum.CrossPlatform.prototype.getConnectivityResponse = function (ignoreLocation) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (navigator)
            return "-1";
        else
            return "-1";
    }

    if (this.isIOS()) {
        return this.Prompt("userConnectivityResponse", {});
    } else if (this.isAndroid()) {
        return this.Prompt("userConnectivityResponse", {});
        //console.log("android todo");
    } 

    return "-1";
}

Atheneum.CrossPlatform.prototype.setConnectivityResponse = function (response, ignoreLocation) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }

    if (this.isIOS()) {
        return this.Prompt("setUserConnectivityResponse", { "connectivityResponse": response });
    } else if (this.isAndroid()) {
        return this.Prompt("setUserConnectivityResponse", { "connectivityResponse": response });
    }

    return false;
}

Atheneum.CrossPlatform.prototype.setUserMaxMobileDownloadSize = function (maxSize, ignoreLocation) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }

    if (this.isIOS()) {
        return this.Prompt("setUserMaxMobileDownloadSize", { "maxSize": maxSize });
    } else if (this.isAndroid()) {
        return this.Prompt("setUserMaxMobileDownloadSize", { "maxSize": maxSize });
    }

    return false;
}

Atheneum.CrossPlatform.prototype.getAssetFileSize = function (assetId, ignoreLocation) {
    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }
    if (this.isIOS()) {
        return this.Prompt("getAssetFileSize", { "assetId": assetId });
    } else if (this.isAndroid()) {
        return this.Prompt("getAssetFileSize", { "assetId": assetId });
    }

    return false;
}


//#region Local Storage
/**
 * Set local storage value for key natively
 * @param {any} key
 * @param {any} value
 */
Atheneum.CrossPlatform.prototype.SetLocalStore = function (key, value) {
    if (key == undefined || value == undefined)
        throw new IllegalArgumentException("key and value must be defined");

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.objectStore.postMessage({ "key": key, "value": value });
    } else if (this.isAndroid()) {
        var obj = { "key": key, "value": value };
        AndroidBridge.objectStore(JSON.stringify(obj));
    } else {
        localStorage[key] = value;
    }

    return this.Callbacks.login;
}

/**
 * Retrieves object for key
 * @param {any} key
 */
Atheneum.CrossPlatform.prototype.GetLocalStore = function (key) {
    if (key == undefined)
        throw new IllegalArgumentException("key was undefined");

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return localStorage[key];
    }

    if (this.isIOS()) {
        return this.Prompt("getlocalstore", { key: key });
    } else if (this.isAndroid()) {
        return this.Prompt("getlocalstore", { key: key });
        //console.log("android todo");
    } else {
        return localStorage[key];
    }

    return this.Callbacks.login;
}

/**
 * Deletes key from storage
 * @param {any} key
 */
Atheneum.CrossPlatform.prototype.ClearLocalStore = function (key) {
    if (key == undefined)
        throw new IllegalArgumentException("key was undefined");

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.objectClear.postMessage({ "key": key });
    } else if (this.isAndroid()) {
        var obj = { "key": key };
        AndroidBridge.objectClear(JSON.stringify(obj));

    } else {
        localStorage[key] = value;
    }

    return this.Callbacks.login;
}

Atheneum.CrossPlatform.prototype.setPageNumber = function (pageNo, assetId, ignoreLocation = false) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }

    if (this.isIOS() || this.isAndroid()) {
        return this.Prompt("setPageNumber", { "pageNo": pageNo, "assetId" : assetId });
    } 

    return false;
}

Atheneum.CrossPlatform.prototype.clearPageNumber = function (ignoreLocation = false) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }

    if (this.isIOS() || this.isAndroid()) {
        return this.Prompt("clearPageNumber", {  });
    } 

    return false;
}

Atheneum.CrossPlatform.prototype.getAssetInfo = function (ignoreLocation = false) {

    if (!ignoreLocation && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return false;
    }

    if (this.isIOS() || this.isAndroid()) {
        let result = this.Prompt("getAssetInfo", {});
        result = result.replaceAll("\\n", "").replaceAll("\\", "");
        return result;
    }

    return "{}";
}

//#endregion

//#region Library
Atheneum.CrossPlatform.prototype.downloadiOSAssetWithId = function (assetId, callback) {
    if (!this.hasMessageHandler()) {
        if (typeof backupURL === 'undefined' || typeof backupURL !== 'string')
            return;

        console.log("No message handlers on iOS");
        return;
    }
    //iOS sends message handler with the request
    window.webkit.messageHandlers.downloadAsset.postMessage({ "assetId": assetId });
}

Atheneum.CrossPlatform.prototype.downloadFinishedForAssetWithId = function (assetId, success, returnJSON) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.assetId === 'undefined' || this.Callbacks.assetId == null)
        return;

    var callbacks = this.Callbacks.assetId;

    if (success)
        callbacks.success(returnJSON);
    else
        callbacks.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);
}

Atheneum.CrossPlatform.prototype.downloadAsset = function (assetId, callbacks) {

    //Add callbacks setup, function will call downloadFinishedForAssetWithId when don which will in turn call the current callback setup
    this.Callbacks.addCallbacks(assetId, callbacks);
    //Different actions for each type of webview
    if (this.isIOS()) {
        this.shareDocument(assetId, 0, 0, 0, 0, callbacks);
    }
}
//#endregion

//#region Utilities
/**
 * Sends a prompt which will be intercepted on iOS and will return a string.
 * What it does with the information provided is dependant on the function name passed to it
 * @param {Object} data json compliant object with information to pass to the bridge
 * @retuns {String} or null
 */

Atheneum.CrossPlatform.prototype.Prompt = function (name, data, force = false) {
    try {

        if (!force && window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0)
            return null;

        var type = "AtheneumBridge";
        var payload = { type: type, functionName: name, data: data };

        var res = prompt(JSON.stringify(payload));

        return res;

    } catch (err) {
        console.log('The native context does not exist yet');
    }

    return null;
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
Atheneum.CrossPlatform.prototype.getMobileOperatingSystem = function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "windowsphone";
    }

    if (this.hasAndroidBridge() || /android/i.test(userAgent)) {
        return "android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod|AppleWebKit/.test(userAgent) && !window.MSStream) {
        return "ios";
    }

    return "web";
}

/**
 * Determmines if the device type is iOS. Checks {hasMessageHandler} is true as well, otherwise
 * it will return false so it can be handled as default web instead
 * @returns {boolean} 
 * */
Atheneum.CrossPlatform.prototype.isIOS = function () {
    return this.deviceType == "ios" && this.hasMessageHandler();
}

/**
 * Determmines if the device type is Android. 
 * @returns {boolean}
 * */
Atheneum.CrossPlatform.prototype.isAndroid = function () {
    return this.deviceType == "android" && this.hasAndroidBridge();
}

/**
 * Determmines if the device type is Windows Phone.
 * @returns {boolean}
 * */
Atheneum.CrossPlatform.prototype.isWindowsPhone = function () {
    return this.deviceType == "windowsphone";
}

/**
 * Determines if message handlers have been setup for the native bridge to Xamarin.iOS
 * @returns {boolean} 
 * */
Atheneum.CrossPlatform.prototype.hasMessageHandler = function () {
    if (!window.webkit || !window.webkit.messageHandlers)
        return false;

    return true;
}

/**
 * Determines if AndroidBridge has been setup for the native bridge to Xamarin.Android
 * @returns {boolean} 
 * */
Atheneum.CrossPlatform.prototype.hasAndroidBridge = function () {
    if (!window.AndroidBridge)
        return false;

    return true;
}

/**
 * Tracking implementation to help track items on pages that unload
 * @param {any} crossPlatform
 */
Atheneum.CrossPlatform.Tracking = function Tracking(crossPlatform) {
    if (!(this instanceof Atheneum.CrossPlatform.Tracking))
        return new Atheneum.CrossPlatform.Tracking();

    this.CrossPlatform = crossPlatform;
}



/**
 * Callbacks implementation to help store and retrieve callbacks due to the
 * async nature of some bridge methods such as iOS message handlers. If synchronous
 * return is required it will be setup through {this.CrossPlatform.Prompt} method
 * @param {any} crossPlatform
 */
Atheneum.CrossPlatform.Callbacks = function Callbacks(crossPlatform) {
    if (!(this instanceof Atheneum.CrossPlatform.Callbacks))
        return new Atheneum.CrossPlatform.Callbacks();

    this.CrossPlatform = crossPlatform;
}

Atheneum.CrossPlatform.Callbacks.prototype.trackAssetView = function (collectionId, assetId, duration, status, timestamp, sessionId, callback) {
    try {
        if (!collectionId || !assetId) {
            console.log("tried tracking asset without asset id");
            return;
        }
        var data = {
            duration: duration,
            status: status,
            userName: this.Atheneum.User.username
        };

        if (sessionId) {
            data.sessionId = sessionId;
        }

        if (timestamp != undefined)
            data.timestamp = timestamp;

        data.collectionId = collectionId;
        data.assetId = assetId;

        this.Callbacks.addCallbacks("trackAsset" + timestamp, callback);

        if (this.isIOS()) {
            //iOS sends message handler with the request
            window.webkit.messageHandlers.trackAssetView.postMessage(data);
        } else if (this.isAndroid()) {
           
            AndroidBridge.login(JSON.stringify(data));
        }

    } catch (err) {
        console.log("error tracking asset through crossplatform");
    }
    
}

/**
 * Adds {callbacks} stored against the {itemId}, only one set of callbacks is currently
 * supported per {itemId}
 * @param {any} itemId
 * @param {any} callbacks
 */
Atheneum.CrossPlatform.Callbacks.prototype.addCallbacks = function (itemId, callbacks) {
    this[itemId] = callbacks;
}

/**
 * Removes callbacks if any present for the given {itemId}
 * @param {any} itemId
 */
Atheneum.CrossPlatform.Callbacks.prototype.removeCallbacks = function (itemId) {
    delete this.itemId;
}

//#region Promises
/**
 * Promises implementation to help store and retrieve promises due to the
 * async nature of some bridge methods such as iOS message handlers. 
 * @param {any} crossPlatform
 */
Atheneum.CrossPlatform.Promises = function Callbacks(crossPlatform) {
    if (!(this instanceof Atheneum.CrossPlatform.Promises))
        return new Atheneum.CrossPlatform.Promises();

    this.CrossPlatform = crossPlatform;
    this.handlers = {};
    this.id = 1;
}

/**
 * Adds {handle} with the resolve and reject from a promise stored against the {itemId}, only one promise is currently
 * supported per {itemId}
 * @param {any} itemId
 * @param {any} promise
 */
Atheneum.CrossPlatform.Promises.prototype.requestPromise = async function (functionName, data) {
    try {
        let response = await new Promise((resolve, reject) => {

        const handle = 'm' + this.id++;
            this.handlers[handle] = { resolve, reject };
            if (this.CrossPlatform.isIOS()) {
                window.webkit.messageHandlers.handlePromise.postMessage({ functionName: functionName, data: data, id: handle });
            } else if (this.CrossPlatform.isAndroid()) {
                var obj = { functionName: functionName, data: data, id: handle };
                AndroidBridge.handlePromise(JSON.stringify(obj));
            }

            

 

        });

        return response;
    } catch (err) {
        return err;
    }
}

/**
 * Promise callback from the app side
 * @param {any} handle
 * @param {any} error
 * @param {any} data
 */
Atheneum.CrossPlatform.Promises.prototype.resolvePromise = function (handle, error, data) {
    if (error) {
        this.handlers[handle].resolve(data);
    } else {
        this.handlers[handle].reject(data);
    }
    delete this.handlers[handle];
}
//#endregion

//#region URL Rewrite
Atheneum.CrossPlatform.prototype.rewriteURL = function (url, ignoreCache) {

    //return url;

    var timestamp = new Date().getTime();
  

    if (!ignoreCache && this.urlRewriteCache.hasOwnProperty(url)) {
        var cachedUrl = this.Atheneum.CrossPlatform.urlRewriteCache[url];
        if (cachedUrl && cachedUrl.indexOf('?') >= 0)
            cachedUrl += "&timestamp=" + timestamp;
        else
            cachedUrl += "?timestamp=" + timestamp;
        return cachedUrl
	}

    if (!this.enabled) {
        return this.Atheneum.Proxy.rewriteURL(url);
    }

    if (typeof url === 'string' && url.startsWith('/'))
        url = (window.location.protocol + '//' + window.location.host) + url;

    try {
        if (!(url instanceof URL))
            url = new URL(url);
    } catch (e) {
        this.urlRewriteCache[url] = url;

        // it's a relative url, or a broken one. Just return it.
        if (url && url.indexOf('?') >= 0)
            url += "&timestamp=" + timestamp;
        else
            url += "?timestamp=" + timestamp;

    	
        return url;
    }

    if (url.origin == (window.location.protocol + '//' + window.location.host)) {
    	this.Atheneum.CrossPlatform.urlRewriteCache[url] = url.href;
        this.Atheneum.CrossPlatform.urlRewriteCache[url.href] = url.href;

        var href = url.href;

        if (href && href.indexOf('?') >= 0)
            href += "&timestamp=" + timestamp;
        else
            href += "?timestamp=" + timestamp;

        return href;
    }

    var match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/([0-9A-Fa-f]+)\/image\.(.+)/);
    if (match) {
        // it's a collection image
    	var rewrittenURL = this.Atheneum.CrossPlatform.GetCollectionThumbnail(match[1]);
    	if(rewrittenURL) {
    		this.urlRewriteCache[url] = rewrittenURL;
    		this.urlRewriteCache[rewrittenURL] = rewrittenURL;
        }

        if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
            rewrittenURL += "&timestamp=" + timestamp;
        else
            rewrittenURL += "?timestamp=" + timestamp;

    	return rewrittenURL;
    }

    match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/[0-9A-Fa-f]+\/([0-9A-Fa-f]+)\/thumb\.(.+)/);
    if (match) {
        // it's an asset thumbnail
    	var rewrittenURL = this.Atheneum.CrossPlatform.GetAssetThumbnail(match[1]);
    	if(rewrittenURL) {
    		this.urlRewriteCache[url] = rewrittenURL;
    		this.urlRewriteCache[rewrittenURL] = rewrittenURL;
        }

        if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
            rewrittenURL += "&timestamp=" + timestamp;
        else
            rewrittenURL += "?timestamp=" + timestamp;

    	return rewrittenURL;
    }

    match = url.pathname.match(/\/dms\/public\/([0-9A-Fa-f]+)\.(.+)/);
    if (match) {
        // it's an arbitrary file
        var filePath = this.Atheneum.CrossPlatform.GetArbitraryFile(match[1]);
        if (filePath) {
        	this.urlRewriteCache[url] = filePath;
            this.urlRewriteCache[filePath] = filePath;

            if (filePath && filePath.indexOf('?') >= 0)
                filePath += "&timestamp=" + timestamp;
            else
                filePath += "?timestamp=" + timestamp;

            return filePath;
        }
    }

    var filePath = this.Atheneum.CrossPlatform.GetArbitraryFileByURL(url);
    if (filePath) {
    	this.urlRewriteCache[url] = filePath;
        this.urlRewriteCache[filePath] = filePath;

        if (filePath && filePath.indexOf('?') >= 0)
            filePath += "&timestamp=" + timestamp;
        else
            filePath += "?timestamp=" + timestamp;

        return filePath;
    }
    
    var rewrittenURL = this.Atheneum.Proxy.rewriteURL(url);
    if (rewrittenURL && rewrittenURL != url) {
    	this.urlRewriteCache[url] = rewrittenURL;
		this.urlRewriteCache[rewrittenURL] = rewrittenURL;
    }

    if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
        rewrittenURL += "&timestamp=" + timestamp;
    else
        rewrittenURL += "?timestamp=" + timestamp;

    return rewrittenURL;
}


Atheneum.CrossPlatform.prototype.rewriteURLPromise = function (url, ignoreCache) {

    var crossPlatform = this;
    var timestamp = new Date().getTime();

    if (!ignoreCache && this.urlRewriteCache.hasOwnProperty(url)) {
        var cachedUrl = crossPlatform.urlRewriteCache[url]
        if (cachedUrl && cachedUrl.indexOf('?') >= 0)
            cachedUrl += "&timestamp=" + timestamp;
        else
            cachedUrl += "?timestamp=" + timestamp;
        return Promise.resolve(cachedUrl);
    }

    if (!this.enabled && this.Atheneum.Proxy.enabled) {
        return Promise.resolve(this.Atheneum.Proxy.rewriteURL(url));
    }

    if (typeof url === 'string' && url.startsWith('/'))
        url = (window.location.protocol + '//' + window.location.host) + url;

    if (!this.enabled) {
        return Promise.resolve(url);
    }

    try {
        if (!(url instanceof URL))
            url = new URL(url);
    } catch (e) {
        // it's a relative url, or a broken one. Just return it.
        var cachedUrl = url;
        if (cachedUrl && cachedUrl.indexOf('?') >= 0)
            cachedUrl += "&timestamp=" + timestamp;
        else
            cachedUrl += "?timestamp=" + timestamp;

        this.urlRewriteCache[url] = url;
        return Promise.resolve(cachedUrl);
    }

    if (url.origin == (window.location.protocol + '//' + window.location.host)) {
        crossPlatform.urlRewriteCache[url] = url.href;
        crossPlatform.urlRewriteCache[url.href] = url.href;
        return Promise.resolve(url.href);
    }

    var match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/([0-9A-Fa-f]+)\/image\.(.+)/);
    if (match) {

        // it's a collection image

        var rewrittenURLPromise = crossPlatform.GetCollectionThumbnailPromise(match[1]);
        var promiseAfterCacheUpdate = rewrittenURLPromise.then(function (rewrittenURL) {
            if (rewrittenURL) {
                crossPlatform.urlRewriteCache[url] = rewrittenURL;
                crossPlatform.urlRewriteCache[rewrittenURL] = rewrittenURL;
            }

            if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
                rewrittenURL += "&timestamp=" + timestamp;
            else
                rewrittenURL += "?timestamp=" + timestamp;

            return rewrittenURL;
        });
        return promiseAfterCacheUpdate;
    }

    match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/[0-9A-Fa-f]+\/([0-9A-Fa-f]+)\/thumb\.(.+)/);
    if (match) {
        // it's an asset thumbnail

        var rewrittenURLPromise = crossPlatform.GetAssetThumbnailPromise(match[1]);
        var promiseAfterCacheUpdate = rewrittenURLPromise.then(function (rewrittenURL) {
            if (rewrittenURL) {
                crossPlatform.urlRewriteCache[url] = rewrittenURL;
                crossPlatform.urlRewriteCache[rewrittenURL] = rewrittenURL;
            }

            if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
                rewrittenURL += "&timestamp=" + timestamp;
            else
                rewrittenURL += "?timestamp=" + timestamp;

            return rewrittenURL;
        });
        return promiseAfterCacheUpdate;
    }


    var filepathRewritePromise;

    match = url.pathname.match(/\/dms\/public\/([0-9A-Fa-f]+)\.(.+)/);
    if (match) {
        // it's an arbitrary file

        filepathRewritePromise = crossPlatform.GetArbitraryFilePromise(match[1]).then(function (rewrittenURL) {
            if (!rewrittenURL) {
                throw new Error("unable to rewrite url")
            }

            if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
                rewrittenURL += "&timestamp=" + timestamp;
            else
                rewrittenURL += "?timestamp=" + timestamp;

            return rewrittenURL;
        });
    }
    else {
        filepathRewritePromise = Promise.reject(new Error("unable to rewrite url"));
    }

    // using ["catch"] because IE treats XYZ.catch as a syntax error

    filepathRewritePromise = filepathRewritePromise['catch'](function () {

        // either it didn't match the previous regex, or no file with that id was available
        // instead, check if there's any file with that url

        return crossPlatform.GetArbitraryFileByURLPromise(url).then(function (rewrittenURL) {
            if (!rewrittenURL) {
                throw new Error("unable to rewrite url")
            }

            if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
                rewrittenURL += "&timestamp=" + timestamp;
            else
                rewrittenURL += "?timestamp=" + timestamp;

            return rewrittenURL;
        });
    });

    // if the url couldn't be rewritten, put it through the proxy
    // or if that's not possible, just return the url we were given

    filepathRewritePromise = filepathRewritePromise['catch'](function () {
        if (crossPlatform.Atheneum.Proxy.enabled) {
            return crossPlatform.Atheneum.Proxy.rewriteURL(url);
        }
        else {
            var rewrittenURL = url;
            if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
                rewrittenURL += "&timestamp=" + timestamp;
            else
                rewrittenURL += "?timestamp=" + timestamp;
            return rewrittenURL;
        }
    });

    // and then update the cache

    filepathRewritePromise = filepathRewritePromise.then(function (rewrittenURL) {
        if (rewrittenURL) {
            crossPlatform.urlRewriteCache[url] = rewrittenURL;
            crossPlatform.urlRewriteCache[rewrittenURL] = rewrittenURL;
        }

        if (rewrittenURL && rewrittenURL.indexOf('?') >= 0)
            rewrittenURL += "&timestamp=" + timestamp;
        else
            rewrittenURL += "?timestamp=" + timestamp;
        return rewrittenURL;
    });

    return filepathRewritePromise;
}
//#endregion


//#region Sync
Atheneum.CrossPlatform.prototype.showSyncReport = function (syncMode, networkSyncMode) {
    if (syncMode === undefined)
        syncMode = 0;
    if (networkSyncMode === undefined)
        networkSyncMode = 1;
   
    if (this.isIOS()) {
        window.webkit.messageHandlers.showSyncReport.postMessage({ "showSyncReport": true, "syncMode": syncMode, "networkSyncMode": networkSyncMode });
    } else if (this.isAndroid()) {
        var obj = { "showSyncReport": true, "syncMode": syncMode, "networkSyncMode": networkSyncMode };
        AndroidBridge.showSyncReport(JSON.stringify(obj));
    } 

}

/**
 * Cross platform implementation of library sync (downloading all assets and thumbnails)
 * @param {any} jsonCallback
 * @param {int} syncMode - 0 Always, 1 - Preview (wont sync through initateSync), 2 - No Video (skips videos), 3 - Small files (skips files bigger than 5mb), 4 - Never (wont sync asset files)
 * @param {int} networkSyncMode - 0 - Syncs with any network, 1 - only cache on wifi, not mobile network, 2 - disallows sync 
 */ 
Atheneum.CrossPlatform.prototype.initiateSync = function (jsonCallback, syncMode, networkSyncMode) {

    if (jsonCallback == "stored")
        jsonCallback = this.Callbacks.initiateSync;

    if (syncMode === undefined)
        syncMode = 0;
    if (networkSyncMode === undefined) {
        var promptText = atheneumInstance.Translation.get('downloadOnMobileDataPrompt', 'Would you like to download files while on mobile data for this session (your response will last until app setting in profile is toggled or the app is restarted)?');
        var mobileDataToggledOn = Atheneum.Theme.TRUE_VALUES.indexOf(atheneumInstance.User.getPreference('salestoolkitAppSettingDownloadOnMobile', 'off', false)) != -1;
        var connectivityResponse = this.getConnectivityResponse();
        if (mobileDataToggledOn || connectivityResponse == "0") {
            //Either it's toggled on or user has accepted mobile downloads for this session
            networkSyncMode = 0;
        }
        else if (this.isMobileNetwork()) {
            //On Mobile network 
            if (connectivityResponse == "1") {
                //User already denied permission for mobile downloads this session
                networkSyncMode = 1;
            }
            else {
                this.Callbacks.addCallbacks("initiateSync", jsonCallback);
                $('#initiateMobileSyncModal').modal('show');
                return;
            }
        } else {
            //On wifi
            networkSyncMode = 1;
        }
    }
    this.Callbacks.addCallbacks("initiateSync", jsonCallback);

    var maxSizeDownloads = atheneumInstance.User.getPreference('salestoolkitAppSettingMobileMaxSize', '0', false);
    maxSizeDownloads = parseFloat(maxSizeDownloads);

    if (this.isIOS()) {
        window.webkit.messageHandlers.initiateSync.postMessage({ "initiateSync": true, "syncMode": syncMode, "networkSyncMode": networkSyncMode, "maxSize": maxSizeDownloads });
    } else if (this.isAndroid()) {
        var obj = { "initiateSync": true, "syncMode": syncMode, "networkSyncMode": networkSyncMode, "maxSize": maxSizeDownloads };
        AndroidBridge.initiateSync(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("initiateSync");
    }

    return this.Callbacks.initiateSync;
}


//#region Sync
/**
* Cross platform implementation of library sync (downloading all assets and thumbnails)
* @param {any} jsonCallback
*/
Atheneum.CrossPlatform.prototype.purgeCache = function (jsonCallback) {

  this.Callbacks.addCallbacks("purgeCache", jsonCallback);
 
  if (this.isIOS()) {
      window.webkit.messageHandlers.purgeCache.postMessage({ "purgeCache": true });
  } else if (this.isAndroid()) {
      var obj = { "purgeCache": true };
      AndroidBridge.purgeCache(JSON.stringify(obj));
  } else {
      this.Callbacks.removeCallbacks("purgeCache");
  }

  return this.Callbacks.purgeCache;
}

/**
 * Callback once cache purge is complete 
 * @param {any} success
 * @param {any} returnJSON
 * @param {any} reason
 * @param {any} httpCode
 * @param {any} errorCode
 */
Atheneum.CrossPlatform.prototype.cachePurgeFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.initiateSync === 'undefined' || this.Callbacks.initiateSync == null)
        return;

    var callbacks = this.Callbacks.initiateSync;

    this.Callbacks.removeCallbacks("initiateSync");

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        //Callbacks all seem to expect a progress object inside the main object
        var progressObject = {};
        progressObject.progress = jsonSuccess;
        callbacks.success(progressObject);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}

/**
 * Callback once sync is completed 
 * @param {any} success
 * @param {any} returnJSON
 * @param {any} reason
 * @param {any} httpCode
 * @param {any} errorCode
 */
Atheneum.CrossPlatform.prototype.initiateSyncFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.initiateSync === 'undefined' || this.Callbacks.initiateSync == null)
        return;

    var callbacks = this.Callbacks.initiateSync;

    this.Callbacks.removeCallbacks("initiateSync");

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        //Callbacks all seem to expect a progress object inside the main object
        var progressObject = {};
        progressObject.progress = jsonSuccess;
        callbacks.success(progressObject);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}

/**
 * Cross platform implementation for getting sync progress 
 * @param {any} callbacks
 * @param {any} onProgress
 */
Atheneum.CrossPlatform.prototype.getSyncProgress = function (callbacks) {

    this.Callbacks.addCallbacks("getSyncProgress", callbacks);

    if (this.isIOS()) {
        window.webkit.messageHandlers.getSyncProgress.postMessage({ "getSyncProgress": true });
    } else if (this.isAndroid()) {
        var obj = { "getSyncProgress": true };
        AndroidBridge.getSyncProgress(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("getSyncProgress");
        if(this.Atheneum.Proxy.enabled) {
        	return Atheneum.HttpUtils.getJSON(
                "restful/library/cache/progress",
                { apikey: this.Atheneum.User.apikey },
                callbacks
            );
        }
        else if(callbacks.offline) {
        	callbacks.offline(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined, 'Atheneum.Cache.getSyncProgress');
        }
        else if(callbacks.failure) {
        	callbacks.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined, 'Atheneum.Cache.getSyncProgress');
        }
    }

    return this.Callbacks.getSyncProgress;
}

/**
 * getSyncProgressFinished
 * @param {any} progressJson
 * @param {any} reason
 * @param {any} httpStatus
 * @param {any} errorCode
 */
Atheneum.CrossPlatform.prototype.getSyncProgressFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything

    if (typeof this.Callbacks.getSyncProgress === 'undefined' || this.Callbacks.getSyncProgress == null)
        return;

    var callbacks = this.Callbacks.getSyncProgress;

    this.Callbacks.removeCallbacks("getSyncProgress");

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
         var progressObject = {};
        progressObject.progress = jsonSuccess;

        if (returnJSON == "{}")
            callbacks.success(jsonSuccess);
        else
            callbacks.success(progressObject);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}
//#endregion

//#region Theme

Atheneum.CrossPlatform.prototype.updateTheme = function (jsonCallback) {

    this.Callbacks.addCallbacks("updateTheme", jsonCallback);

    if (this.isIOS()) {
        window.webkit.messageHandlers.updateTheme.postMessage({ "updateTheme": true });
    } else if (this.isAndroid()) {
        var obj = { "updateTheme": true };
        AndroidBridge.updateTheme(JSON.stringify(obj));
    } else {
        return this.Atheneum.API.getTheme(undefined, jsonCallback);
    }

    return this.Callbacks.updateTheme;
}


Atheneum.CrossPlatform.prototype.updateThemeFinished = function (success, returnJSON, reason, httpCode, errorCode) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.updateTheme === 'undefined' || this.Callbacks.updateTheme == null)
        return;

    var callbacks = this.Callbacks.updateTheme;

    if (success) {
        var jsonSuccess = JSON.parse(returnJSON);
        callbacks.success(jsonSuccess);
    }
    else if (typeof callbacks.failure === "function")
        callbacks.failure(reason, httpCode, errorCode);
}

//#endregion

//#region Utility
Atheneum.CrossPlatform.prototype.convertImageToBase64 = function (fileUpload, callback) {

    var successCallback = typeof callback === "function" ? callback : callback.success;

    var form = fileUpload.parentNode;
    //var prevNode = fileUpload.previousSibling;

    while (form && form.tagName.toUpperCase() != "FORM")
        form = form.parentNode;

    if (form == null) {
        // give up
        return;
    }

    var iframeHolder = document.createElement('DIV');
    iframeHolder.style.display = 'none';
    document.body.appendChild(iframeHolder);

    iframeHolder.innerHTML = '<iframe id="atheneum-ie9-file-uploader" name="atheneum-ie9-file-uploader"></iframe>';
    var iframe = iframeHolder.children[0];

    form.setAttribute('target', 'atheneum-ie9-file-uploader')

    iframe.onload = function () {

        var iframeDocument = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (!iframeDocument || !iframeDocument.body)
            return;

        if (!iframeDocument.documentURL || iframeDocument.documentURL == "javascript: false")
            return;

        var base64imageData = iframeDocument.body.innerHTML;
        document.body.removeChild(iframeHolder);

        if (typeof successCallback === "function")
            successCallback(base64imageData);
    }

    form.submit();
}
//#endregion


/**
 * Retrieves arbitrary file by id
 * @param {string} fileId
 */
Atheneum.CrossPlatform.prototype.GetArbitraryFile = function (fileId) {
    if (fileId == undefined)
        throw new IllegalArgumentException("fileId was undefined");

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return null;
    }

    if (this.isIOS()) {
        return this.Prompt("file", { id: fileId });
    } else if (this.isAndroid()) {
        return this.Prompt("file", { id: fileId });

        //var obj = prompt("file", { id: fileId  });
        //AndroidBridge.updateTheme(JSON.stringify(obj));

    } else {
        return null;
    }

    return this.Callbacks.login;
}
Atheneum.CrossPlatform.prototype.GetArbitraryFilePromise = function (fileId) {
    if (fileId == undefined)
        throw new IllegalArgumentException("fileId was undefined");

    if (this.isIOS()) {
        return this.Promises.requestPromise("file", { id: fileId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("file", { id: fileId });
    }

    return Promise.resolve(null);
}

/**
 * Retrieves arbitrary file by url
 * @param {string} fileId
 */
Atheneum.CrossPlatform.prototype.GetArbitraryFileByURL = function (url) {
    if (url == undefined)
        throw new IllegalArgumentException("url was undefined");

    var url = '' + url;

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return null;
    }

    if (this.isIOS()) {
        return this.Prompt("file", { url: url });
    } else if (this.isAndroid()) {
        return this.Prompt("file", { url: url });
    } else {
        return null;
    }

    return this.Callbacks.login;
}

/**
 * Returns a promise that resolves with the local url for the file with arbitrary url
 * @param {string} fileId
 */
Atheneum.CrossPlatform.prototype.GetArbitraryFileByURLPromise = function (url) {
    if (url == undefined)
        throw new IllegalArgumentException("url was undefined");

    var url = '' + url;

    if (this.isIOS()) {
        return this.Promises.requestPromise("file", { url: url });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("file", { url: url });
        //return Promise.resolve(url);
    }

    return Promise.resolve(url);
}


//#region Thumbnails
/**
 * Retrieves asset thumbnail for asset
 * @param {object} asset
 */
Atheneum.CrossPlatform.prototype.GetAssetThumbnail = function (asset) {
    if (asset == undefined)
        throw new IllegalArgumentException("assetId was undefined");

    var assetId = null;
    if (typeof asset === 'string') {
        assetId = asset;
        asset = this.Atheneum.Library.assets[assetId];
    }
    else if (typeof asset === 'object') {
        assetId = asset.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return this.Atheneum.DefaultImages.Asset;
    }

    if (this.isIOS()) {
        return this.Prompt("assetThumb", { id: assetId });
    } else if (this.isAndroid()) {
        return this.Prompt("assetThumb", { id: assetId });
    } else {
        if (asset.thumb && asset.thumb.url)
            return asset.thumb.url;
        else
            return this.Atheneum.DefaultImages.Asset;
    }

    return this.Callbacks.login;
}


Atheneum.CrossPlatform.prototype.GetAssetThumbnailPromise = function (asset) {
    if (asset == undefined)
        throw new IllegalArgumentException("assetId was undefined");

    var assetId = null;
    if (typeof asset === 'string') {
        assetId = asset;
        asset = this.Atheneum.Library.assets[assetId];
    }
    else if (typeof asset === 'object') {
        assetId = asset.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("assetThumb", { id: assetId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("assetThumb", { id: assetId });
    }

    if (asset.thumb && asset.thumb.url) {
        return Promise.resolve(asset.thumb.url);
    }
    else {
        return Promise.resolve(this.Atheneum.DefaultImages.getForAssetWithMimeType(asset.mimetype));
    }
}

/**
 * Retrieves asset thumbnail for collection
 * @param {object|string} collection
 */
Atheneum.CrossPlatform.prototype.GetCollectionThumbnail = function (collectionOrId) {
    if (collectionOrId == undefined)
        throw new IllegalArgumentException("collection/collectionId was undefined");
    
    var collectionId = undefined;
    if(typeof collectionOrId === 'string') {
    	collectionId = collectionOrId;
    }
    else if(typeof collectionOrId === 'object') {
    	collectionId = collectionOrId.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return this.Atheneum.DefaultImages.Collection;
    }

    if (this.isIOS()) {
        return this.Prompt("collectionThumb", { id: collectionId });
    } else if (this.isAndroid()) {
        return this.Prompt("collectionThumb", { id: collectionId });
    } else {
        var collection = (typeof collectionOrId === 'object') ? collectionOrId : this.Atheneum.Library.collections[collectionId];
        if (collection.image && collection.image.url)
            return collection.image.url;
        else
            return this.Atheneum.DefaultImages.Collection;
    }

    return this.Callbacks.login;
}

Atheneum.CrossPlatform.prototype.GetCollectionThumbnailPromise = function (collectionOrId) {
    if (collectionOrId == undefined)
        throw new IllegalArgumentException("collection/collectionId was undefined");

    var collectionId = undefined;
    if (typeof collectionOrId === 'string') {
        collectionId = collectionOrId;
    }
    else if (typeof collectionOrId === 'object') {
        collectionId = collectionOrId.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("collectionThumb", { id: collectionId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("collectionThumb", { id: collectionId });
        //console.log("android todo");
    }

    var collection = (typeof collectionOrId === 'object') ? collectionOrId : this.Atheneum.Library.collections[collectionId];
    if (collection.image && collection.image.url) {
        return Promise.resolve(collection.image.url);
    }
    else {
        return Promise.resolve(this.Atheneum.DefaultImages.Collection);
    }
}

/**
 * Retrieves feed item thumbnail for asset
 * @param {object} feedItem
 */
Atheneum.CrossPlatform.prototype.GetFeedItemThumbnail = function (feedItem) {
    if (feedItem == undefined)
        throw new IllegalArgumentException("feedItem was undefined");

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        var thumbnail = feedItem.thumbnail || feedItem.thumb || null;
        if (typeof thumbnail === 'string' && thumbnail.length > 0) {
            return thumbnail;
        }
        if (thumbnail && thumbnail.url)
            return thumbnail.url;
        else
            return null;
    }

    if (this.isIOS()) {
        return this.Prompt("feedItemThumb", { id: feedItem.id });
    } else if (this.isAndroid()) {
        return this.Prompt("feedItemThumb", { id: feedItem.id });
        //console.log("android todo");
    } else {
    	var thumbnail = feedItem.thumbnail || feedItem.thumb || null;
    	if(typeof thumbnail === 'string' && thumbnail.length > 0) {
    		return thumbnail;
    	}
        if (thumbnail && thumbnail.url)
            return thumbnail.url;
        else
            return null;
    }

    return this.Callbacks.login;
}
Atheneum.CrossPlatform.prototype.GetFeedItemThumbnailPromise = function (feedItem) {
    if (feedItem == undefined)
        throw new IllegalArgumentException("feedItem was undefined");

    if (this.isIOS()) {
        return this.Promises.requestPromise("feedItemThumb", { id: feedItem.id });
    } else if (this.isAndroid()) {
        return this.Promises.requestPromise("feedItemThumb", { id: feedItem.id });
        //console.log("android todo");
    }

    var thumbnail = feedItem.thumbnail || feedItem.thumb || null;
    if (typeof thumbnail === 'string' && thumbnail.length > 0) {
        return Promise.resolve(thumbnail);
    }
    if (thumbnail && thumbnail.url)
        return Promise.resolve(thumbnail.url);
    else
        return Promise.resolve(null);
}

/**
 * Retrieves plugin thumbnail 
 * @param {object} plugin
 */
Atheneum.CrossPlatform.prototype.GetPluginThumbnail = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (plugin.thumb && plugin.thumb.url)
            return plugin.thumb.url;
        else
            return this.Atheneum.DefaultImages.PluginLibrary;
    }

    if (this.isIOS()) {
        return this.Prompt("pluginThumb", { id: pluginId });
    } else if (this.isAndroid()) {
        return this.Prompt("pluginThumb", { id: pluginId });
    } else {
        if (plugin.thumb && plugin.thumb.url)
            return plugin.thumb.url;
        else
            return this.Atheneum.DefaultImages.PluginLibrary;
    }
}


Atheneum.CrossPlatform.prototype.GetPluginThumbnailPromise = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("pluginThumb", { id: pluginId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("pluginThumb", { id: pluginId });
    }

    if (plugin.thumb && plugin.thumb.url) {
        return Promise.resolve(plugin.thumb.url);
    }
    else {
        return Promise.resolve(this.Atheneum.DefaultImages.PluginLibrary);
    }
}

/**
 * Retrieves plugin icon 
 * @param {object} plugin
 */
Atheneum.CrossPlatform.prototype.GetPluginIcon = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (plugin.icon && plugin.icon.url)
            return plugin.icon.url;
        else
            return this.Atheneum.DefaultImages.PluginIcon;
    }

    if (this.isIOS()) {
        return this.Prompt("pluginIcon", { id: pluginId });
    } else if (this.isAndroid()) {
        return this.Prompt("pluginIcon", { id: pluginId });
    } else {
        if (plugin.icon && plugin.icon.url)
            return plugin.icon.url;
        else
            return this.Atheneum.DefaultImages.PluginIcon;
    }
}


Atheneum.CrossPlatform.prototype.GetPluginIconPromise = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("pluginIcon", { id: pluginId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("pluginIcon", { id: pluginId });
    }

    if (plugin.icon && plugin.icon.url) {
        return Promise.resolve(plugin.icon.url);
    }
    else {
        return Promise.resolve(this.Atheneum.DefaultImages.PluginIcon);
    }
}

/**
 * Retrieves plugin icon 
 * @param {object} plugin
 */
Atheneum.CrossPlatform.prototype.GetSmallPluginIcon = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        if (plugin.smallIcon && plugin.smallIcon.url)
            return plugin.smallIcon.url;
        else
            return this.Atheneum.DefaultImages.PluginSmallIcon;
    }

    if (this.isIOS()) {
        return this.Prompt("pluginSmallIcon", { id: pluginId });
    } else if (this.isAndroid()) {
        return this.Prompt("pluginSmallIcon", { id: pluginId });
    } else {
        if (plugin.smallIcon && plugin.smallIcon.url)
            return plugin.smallIcon.url;
        else
            return this.Atheneum.DefaultImages.PluginSmallIcon;
    }
}


Atheneum.CrossPlatform.prototype.GetPluginSmallIconPromise = function (plugin) {
    if (plugin == undefined)
        throw new IllegalArgumentException("plugin was undefined");

    var pluginId = null;
    if (typeof plugin === 'string') {
        pluginId = plugin;
    }
    else if (typeof plugin === 'object') {
        pluginId = plugin.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("pluginSmallIcon", { id: pluginId });
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("pluginSmallIcon", { id: pluginId });
    }

    if (plugin.smallIcon && plugin.smallIcon.url) {
        return Promise.resolve(plugin.smallIcon.url);
    }
    else {
        return Promise.resolve(this.Atheneum.DefaultImages.PluginSmallIcon);
    }
}

/**
 * Retrieves the profile image for a user
 * @param {object} feedItem
 */
Atheneum.CrossPlatform.prototype.GetUserProfileImage = function (user) {
   
    if (user == undefined) {
        console.log("Atheneum.CrossPlatform.GetUserProfileImage - user was undefined");
        return null;
    }

    var userId = null;
    if (typeof user === 'string') {
        userId = user;
        user = { id: userId };
    }
    else if (typeof user === 'object' && user.id) {
        userId = user.id;
    }

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        var userImage = user.profileImg || user.image || null;
        if (this.Atheneum.Proxy.enabled) {
            userImage = "/restful/imageCache/user/" + comment.userId;
        }
        return userImage;
    }


    if (this.isIOS()) {
        return this.Prompt("userProfileImg", { id: userId }) || null;
    } else if (this.isAndroid()) {
        return this.Prompt("userProfileImg", { id: userId }) || null;
    } else {
        var userImage = user.profileImg || user.image || null;
        if (this.Atheneum.Proxy.enabled) {
            userImage = "/restful/imageCache/user/" + comment.userId;
        }
        return userImage;
    }

    return null;
}


Atheneum.CrossPlatform.prototype.GetUserProfileImagePromise = function (user) {

    if (user == undefined) {
        console.log("Atheneum.CrossPlatform.GetUserProfileImage - user was undefined");
        return Promise.resolve(null);
    }

    var userId = null;
    if (typeof user === 'string') {
        userId = user;
        user = { id: userId };
    }
    else if (typeof user === 'object' && user.id) {
        userId = user.id;
    }

    if (this.isIOS()) {
        return this.Promises.requestPromise("userProfileImg", { id: userId }) || null;
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("userProfileImg", { id: userId }) || null;
    }

    var userImage = user.profileImg || user.image || null;
    if (this.Atheneum.Proxy.enabled) {
        userImage = "/restful/imageCache/user/" + comment.userId;
    }
    return Promise.resolve(userImage);
}
//#endregion

//#region Content URLs
Atheneum.CrossPlatform.prototype.GetFeedItemContent = function (feedItem) {
    if (feedItem == undefined)
        throw new IllegalArgumentException("feedItem was undefined");

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return null;
    }

    if (this.isIOS()) {
        return this.Prompt("feedItemContent", { id: feedItem.id });
    } else if (this.isAndroid()) {
        return this.Prompt("feedItemContent", { id: feedItem.id });
    } else {
        return null;
    }

    return this.Callbacks.login;
}

Atheneum.CrossPlatform.prototype.GetFeedItemContentPromise = function (feedItem) {
    if (feedItem == undefined)
        throw new IllegalArgumentException("feedItem was undefined");

    if (this.isIOS()) {
        return this.Promises.requestPromise("feedItemContent", { id: feedItem.id });
    } else if (this.isAndroid()) {
        return this.Promises.requestPromise("feedItemContent", { id: feedItem.id });
    }

    return Promise.resolve(null);
}
//#endregion

/**
 * gets startup url
 */
Atheneum.CrossPlatform.prototype.getStartURL = function () {
    if (this.isIOS()) {
        return this.Prompt("startupURL", {});
    } else if (this.isAndroid()) {
        return this.Prompt("startupURL", {});
    } else {
        return null;
    }  
}

/**
 * gets app path
 */
Atheneum.CrossPlatform.prototype.getiOSAppPath = function () {
    if (!this.isIOS()) 
        return "";

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {

        return "";
    }

    return this.Prompt("getAppPath", {});
}


/**
 * gets app device info
 */
Atheneum.CrossPlatform.prototype.getDeviceInfo = function () {
    if (!this.deviceInfo || this.deviceInfo == null) {

        if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) 
            return null;

        if (this.isIOS()) {
            this.deviceInfo = this.Prompt("getDeviceInfo", {});
        } else if (this.isAndroid()) {
            this.deviceInfo = this.Prompt("getDeviceInfo", {});
        } else {
            this.deviceInfo = null;
        }
    }

    return this.deviceInfo;
   
}


/**
 * gets version
 */
Atheneum.CrossPlatform.prototype.getVersion = function () {
    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return null;
    }

    if (this.isIOS()) {
        return this.Prompt("getVersion", {});
    } else if (this.isAndroid()) {
        return this.Prompt("getVersion", {});
    } else {
        return null;
    }
}



Atheneum.CrossPlatform.prototype.getResourcesURL = function () {

    if (window.location.href.contains("viewAsset") && document.getElementsByTagName('video').length > 0) {
        return null;
    }

    if (this.isIOS()) {
        return this.Prompt("getResourcesURL", {});
    } else if (this.isAndroid()) {
        return this.Prompt("getResourcesURL", {});
    } else {
        return null;
    }
}

//#region status bar
//#region Login Region
/**
 * CrossPlatform implementation of login. Handles login request and persists
 * the user data in the sqlite db. {jsonCallback} is an object that contains a
 * 
 
 * @param {any} username
 * @param {any} password
 * @param {any} jsonCallback object containing success function(jsonObj) and a failure function(reason, httpCode, errorCode)
 */
Atheneum.CrossPlatform.prototype.SetStatubarStyle = function (style) {
	
    if (style !== 'black' && style !== 'white')
        throw new IllegalArgumentException("style must be black or white");
   
    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.setStatubarStyle.postMessage({ "style": style });
    } else if (this.isAndroid()) {
        var obj = { "style": style };
        AndroidBridge.setStatubarStyle(JSON.stringify(obj));
    } 
}
Atheneum.CrossPlatform.prototype.SetStatusbarStyle = Atheneum.CrossPlatform.prototype.SetStatubarStyle;
//#endregion

Atheneum.CrossPlatform.prototype.forceUpdateProfilePic = function (base64Img) {
    var obj = { "update": true };
    if (base64Img)
        obj.base64Img = base64Img;

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.forceUpdateProfilePic.postMessage(obj);
       // this.Cache.removeLocalCachedValue('userprofile');
    } else if (this.isAndroid()) {
        //var obj = { "count": count };
        AndroidBridge.forceUpdateProfilePic(JSON.stringify(obj));
    }
}
Atheneum.CrossPlatform.prototype.forceUpdateProfilePicPromise = function (base64Img) {
    var obj = { "update": true };
    if (base64Img)
        obj.base64Img = base64Img;

    if (this.isIOS()) {
        return this.Promises.requestPromise("update", obj);
        // this.Cache.removeLocalCachedValue('userprofile');
    }
    else if (this.isAndroid()) {
        return this.Promises.requestPromise("update", obj);
    }
    return Promise.resolve(null);
}

Atheneum.CrossPlatform.prototype.finishedUpdatingProfilePic = function (success) {
    //TODO
}

//#region cache
Atheneum.CrossPlatform.prototype.removeLocalCachedValue = function (key) {
    window.localStorage.removeItem[key];
}

Atheneum.CrossPlatform.prototype.setLocalCacheValue = function (key, value) {
    window.localStorage.setItem(key,value);
}

Atheneum.CrossPlatform.prototype.getLocalCacheValue = function (key) {
    return window.localStorage.getItem(key);
}
//#endregion 

Atheneum.CrossPlatform.prototype.reportOfflineActionsCount = function (count) {
    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.reportOfflineActionsCount.postMessage({ "count": count });
    } else if (this.isAndroid()) {
        var obj = { "count": count };
        AndroidBridge.reportOfflineActionsCount(JSON.stringify(obj));
    }
}

//#region Plugins Region
/**
 * CrossPlatform implementation of plugins. Handles plugin request 
 * 
 */
Atheneum.CrossPlatform.prototype.getPlugins = function (callbacks) {

    if (typeof callbacks !== 'undefined' && callbacks != null && typeof callbacks !== 'function')
        throw new IllegalArgumentException("callbacks must be a function");

    this.Callbacks.addCallbacks("getPlugins", callbacks);

    if (this.isIOS()) {
        //iOS sends message handler with the request
        window.webkit.messageHandlers.getPlugins.postMessage({ "getPlugins": true });
    } else if (this.isAndroid()) {
        var obj = { "getPlugins" : true };

        AndroidBridge.getPlugins(JSON.stringify(obj));
    } else {
        this.Callbacks.removeCallbacks("getPlugins");
    }

    return this.Callbacks.getPlugins;
}

/**
 * Callback from native code once getPlugins is finished
 * @param {any} returnJSON plugin json array
 */
Atheneum.CrossPlatform.prototype.getPluginsFinished = function (returnJSON) {
    //If no callbacks setup no need to do anything
    if (typeof this.Callbacks.getPlugins === 'undefined' || this.Callbacks.getPlugins == null)
        return;

    var callbacks = this.Callbacks.getPlugins;

    var jsonSuccess = JSON.parse(returnJSON);
    callbacks(jsonSuccess);
}

/** SINGLE SIGN ON HELPERS */
Atheneum.CrossPlatform.prototype.getLoginJSON = function () {

    var json = this.Prompt("loginJSON", {});
    if (json && json !== "")
        return JSON.parse(json);
    return null;
}

Atheneum.CrossPlatform.prototype.getLoginError = function () {
    return this.Prompt("loginError", {});
}

Atheneum.CrossPlatform.prototype.getSafeAreaMargins = function () {
    return this.Prompt("getSafeAreaMargins", {}, true);
}

Atheneum.CrossPlatform.prototype.logMessage = function (message) {

    try {
        const msg = {
            log: message
        }

        if (window.webkit) {
            window.webkit.messageHandlers.log.postMessage(msg);
        //}
        //else if (window.AndroidBridge) {
        //    AndroidBridge.handleJavascriptError(JSON.stringify(obj));
        } else {
            console.log("Error:", msg);
        }
    } catch (err) {
        console.log("Error:", msg);
    }
}

console.log("atheneumAPI.CrossPlatform.js - loaded");